import React, { useEffect, useState } from 'react'
import { accept_invite,  get_event } from '../Api/data'
import { useSearchParams } from 'react-router-dom'
import { Global } from '@emotion/react';
import { styled } from '@mui/material/styles';

import { grey } from '@mui/material/colors';

import Box from '@mui/material/Box';

import './home.css'
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { guest_dp_list } from '../Api/storage';
// import AppBanner from "smart-app-banner-react";
import { AiOutlineCheckCircle } from "react-icons/ai";

const Root = styled('div')(({ theme }) => ({
  height: '100%',
  backgroundColor:
    theme.palette.mode === 'light' ? grey[100] : theme.palette.background.default,
}));

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light' ? '#141414' : "#141414",
}));

let title = ""

function Home() {
  const searchParams = useSearchParams()

  // const id = searchParams.get('i')
  const paramIDS = searchParams.get('u')  
  const [uid, id] =  paramIDS.split("--i=") 
  const [authorName, setAuthorName] = useState("")
  const [data, setData] = useState({})
  const [date, setDate] = useState(new Date())
  const [startTime, setStartTime] = useState("")
  const [endTime, setEndTime] = useState("")
  const [guestUID, setGuestUID] = useState("")

  const [displayInvite, setdisplayInvite] = useState(false)
  const drawerBleeding = 56;
  const [open, setOpen] = React.useState(false);
  const [showMaybeButton, setShowMaybeButton] = useState(false)
  const [showMaybeOptions, setShowMaybeOptions] = useState(false)  
  const [invited, setInvited] = useState(false)
  const [maybe, setMaybe] = useState(false)
  const [drawerType, setdrawerType] = useState("missing")
  const [firebaseFiles, setFirebaseFiles] = useState([]);
  const [invites, setInvites] = useState([]);
  const [topThree, setTopThree] = useState([]);
  const [declined, setDeclined] = useState(false)

  const text = {
    missing: "Download the Surge Party app to not miss out on future parties.",
    in: "Download the Surge Party app to upload your playlist and listen to your favorite songs in the party.",
    maybe:"Please come back when you have changed your mind."
  }

  const heading = {
    missing: `Ohh, you're missing out on ${data.title}`,
    in: "You have been surged in",
    maybe: "No worries"
  }
    
  useEffect(()=> {    
  
    fetchEventData()    
    const q = searchParams.get('u')            
  }, [])

  const fetchEventData = async() => {
    const post = await get_event(uid, id)   
 
    
    const files = await guest_dp_list()
    setFirebaseFiles(files);
       
    const gUID = localStorage.getItem('uid')
  
    setGuestUID(gUID)
      
    setData(post)
    title = post.title    
    const dat = post?.date?new Date(post.date):new Date()
    setDate(dat)
    setStartTime(date.toLocaleTimeString([], {timeStyle: 'short'}))    
    var unixTime = dat.getTime()
    let total = unixTime+parseInt(post?.duration)*60*60*1000
    var d = new Date(total);
    setEndTime(d.toLocaleTimeString([], {timeStyle: 'short'}))   
    let all_invites = post.invites
    let dpPresent = []
    let dpAbsent = []
    Object.keys(all_invites).map((invUID) => {
      if (files.includes(invUID)) {
      
        if (invUID === uid) {
          dpPresent.push(invUID)
        } else {
        
          dpAbsent.push(invUID)
        }
      } else {
        dpAbsent.push(invUID)
      }
    })
    const invs = dpPresent.concat(dpAbsent)
    setInvites(invs);    
    setTopThree(invs.slice(0, 5))
    if(gUID == post.author){
      setdisplayInvite(false) 
    }else{
   
      if(!Object.keys(all_invites).includes(gUID)){    
              
        setdisplayInvite(true)
      }else{
        
        if(all_invites[gUID] == "Maybe"){
          setShowMaybeButton(true)
          setdisplayInvite(false) 
          setMaybe(true)
        }else if(all_invites[gUID] == "NA"){
          setdisplayInvite(true)
        }else if(all_invites[gUID] == "No"){
          setDeclined(true)          
        }
        else{
          setInvited(true)
          setdisplayInvite(false) 
        }        
      }   
    }

  }

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const accept_invitation = async(status) =>{    
    const input = {      
      id: id,
      uid: guestUID,
      author: data.author,
      status: status
    }
    const message = await accept_invite(input)
   
  }

  const container = window !== undefined ? () => window().document.body : undefined;


  const SurgemeinCont = () => {
    return(<></>)
  }

  const Puller = styled(Box)(({ theme }) => ({
    width: 30,
    height: 6,
    backgroundColor: grey[300],
    borderRadius: 3,
    position: 'absolute',
    top: 15,
    left: 'calc(50% - 15px)',
  }));

  const appInfo = {
    imageUrl:window.location.origin + '/icon.jpg',
    name: 'Surge Party',
    publisher: 'Surge Party',
    infoText: 'Free - In App Store',
    linkButtonText: 'VIEW',
    linkUrl:'https://apps.apple.com/us/app/surge-party/id1643038656'
  }

  return (    
    <div>     
      {/* <AppBanner></AppBanner> */}
      <div className='row' style={{justifyContent:'space-between', padding: 10}}>
        <div style={{width: 40}}></div>
        <div>
        <h2 style={{textAlign: 'center'}}>Event Details</h2>           
        </div>
        <div onClick={() => {
          localStorage.setItem('email','')
          window.location.reload();          
        }}>
          <img className='img_event' style={{width: 35, height: 35, padding:10}} src={window.location.origin + '/logoutIcon.svg'} />
        </div>
      </div>

      
      {data?.eventBanner ? (
        <img className='img_event' src={data?.eventBanner} />  
      ): (<img className='img_event' src={window.location.origin + '/icon.jpg'} />)}
      {/* <img className='img_event' src={window.location.origin + '/icon.jpg'} /> */}
      <div className='details_main'>
        <h2 className='title'>{data.title}</h2>        
        <p style={{ display: 'flex', gap: 5, fontSize: 18 }}>Created by: <p className='magenta' style={{fontSize:18}}>{data.author == guestUID ? "You" : data.authorName}</p></p>
        
        <div className='row2'>
          <div className='row3'>
            <span class="icon1"></span>            
            <p>{startTime} - {endTime}</p>
          </div>
          <div className='row3'>
            <span class="icon2"></span>            
            <p>{date.toLocaleDateString()}</p>
          </div>          
        </div>
        <div className='row'>
          <h4>Duration: </h4>            
          <p>{Math.ceil(data.duration)} hrs</p>
        </div>
        <div className='row' style={{width: "95%"}}>
          <span class="icon3"></span>        
            <a style={{color: 'white'}} target="_blank" href={`https://www.google.com/maps/search/?api=1&query=${data?.latlong?.latitude},${data?.latlong?.longitude}`}>{data?.location}</a>
          </div>
        </div>

      <div className='row guest-im-container'>
        <div className=''>
          {topThree.map((item, i) => {            
            if(firebaseFiles.includes(item)){
              return(<img style={{right:i*10}} className='circle-image' src={`https://firebasestorage.googleapis.com/v0/b/surge-party.appspot.com/o/users%2F${item}%2Fprofilepic?alt=media&token=0a3b87c0-0e01-4681-bd2c-71a753447fc5`}/>)
            }else{
              return(<img style={{right:i*10}}  src={window.location.origin + '/icon.jpg'} className='circle-image'/>)
            }
          })}
        </div>
        <div className='guest-count-container row'>
          <div className='row'>            
            <img style={{width:40, height: 20}} src={window.location.origin + '/guestIcon.svg'}/>
            <p>{invites.length} Guests</p>
          </div>
        </div>
      </div>

      <div className='description_container'>
        <h3>Description</h3>
        <p className='desc_text'>{guestUID==data.author? <p style={{color:'600'}} className='magenta'>"You are the host of the party. Please go back to the app to see your event."</p> : "If you want to submit your playlist, download the app and login using the same email as above."}</p>
        <p className='magenta' style={{fontSize:18, fontWeight:'600', textAlign:'center', marginLeft:10, marginRight:10}}>{invited? "You are added to the Guestlist":""}</p>
        <p className='magenta' style={{fontSize:18, fontWeight:'600', textAlign:'center', marginLeft:10, marginRight:10}}>{declined? "You have declined the invitation to this event.":""}</p>
      </div>

      {displayInvite? (
        <div>
          {showMaybeOptions ? (
            <div className='redirect_container row'>
              <a className='grey_button surge_in' onClick={() => {
                  setdrawerType("missing")
                  accept_invitation("No")       
                  setDeclined(true)
                  setdisplayInvite(false)
                  setOpen(true)                                    
                }}>Decline</a>
              <a className='maybe_button surge_in' onClick={() => {
                  accept_invitation("Maybe")            
                  setdrawerType("maybe")
                  setOpen(true)
                  setdisplayInvite(false)
                  setShowMaybeButton(true)
                }}>Maybe</a>        
            </div>
          ): (
            <div className='redirect_container row'>
              <a className='grey_button surge_in' onClick={() => {          
                  if(!maybe){
                    setShowMaybeOptions(true)
                  }else{
                    setdrawerType("missing")
                    setOpen(true)
                    setdisplayInvite(false)
                  }
                  
                }}>I'm not Going</a>
              <a className='accept_button surge_in' onClick={() => {
                  accept_invitation("Yes")            
                  setdrawerType("in")
                  setOpen(true)
                  setdisplayInvite(false)
                  setShowMaybeButton(false)
                  setInvited(true)
                }}>Surge Me In</a>        
            </div>
          )}          
        </div>
      ): (
        <>
          {showMaybeButton ? (
            <div className='redirect_container row'>
              <a className='pink_button surge_in' onClick={() => {          
                  setShowMaybeOptions(false)
                  setMaybe(true)
                  setdisplayInvite(true)                  
                }}>I have changed my mind</a>                
          </div>
          ): <></>}
        </>
      )}
      
      {/* <Root> */}
      {/* <CssBaseline /> */}
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            height: `calc(50% - ${drawerBleeding}px)`,
            overflow: "visible",
            margin: "10px",
            borderRadius: "10px",           
          },
        }}
      />
      <SwipeableDrawer        
        anchor="bottom"
        open={open}        
        transitionDuration={500}        
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        // sx={{
        //   margin: 2,
        // }}
        // classes={{paper: {background:"transparent"}}}
        ModalProps={{
          keepMounted: true,
        }}        
      > 
        <StyledBox
          sx={{
            px: 2,
            pb: 2,
            borderRadius: "10px",  
            background: '#141414',            
            height: '100%',                      
          }}
        >         
        <Puller />
        <div className='drawer_cont'>
          <div>
            {drawerType == "missing" ? (<img className='img_event' style={{width: 120, height: 120, filter: "grayscale(100%)"}} src={window.location.origin + '/groupDance.svg'} />):(
            <>
            {drawerType == "maybe"? (
              <img className='img_event' style={{width: 120, height: 120}} src={window.location.origin + '/groupDance.svg'} />
            ): (
              <AiOutlineCheckCircle size={120} color="#2fd566"/>
            )}</>
            )}            
          </div>
          <div>
            <h3 className='drawer_heading'>{heading[drawerType]}</h3>            
            <p className='white' style={{textAlign:'center'}}>{text[drawerType]}</p>            
          </div>
         
        </div>      
        <a className='button-download-container' href='https://apps.apple.com/us/app/surge-party/id1643038656'>        
          <div className='button-white'>
          <img className='img_event' style={{width: 25, height: 15}} src={window.location.origin + '/downloadIcon.svg'} />
            <a className='btn-wtext'>Download Surge Party</a>
          </div>
        </a>                      
        </StyledBox>
      </SwipeableDrawer>
      {/* </Root> */}
      {/* <SurgemeinCont/>       */}
    </div>
    
  )
}

export default Home